// src/contexts/ResultsContext.jsx
import React, { createContext, useState } from 'react';

export const ResultsContext = createContext();

export const ResultsProvider = ({ children }) => {
  const [results, setResults] = useState([]);

  const addResult = (result) => {
    setResults((prevResults) => [...prevResults, result]);
  };

  return (
    <ResultsContext.Provider value={{ results, addResult }}>
      {children}
    </ResultsContext.Provider>
  );
};
